export default {
  title: 'Confirmation',
  closeButton: 'Back',
};
